import { createAction } from 'redux-actions';
export const fetchFreshDeviations = createAction(`EDITOR.FETCH_FRESH_DEVIATIONS`, ({ deviations, setEntityData })=>({
        deviations,
        setEntityData
    }));

//# sourceMappingURL=actionCreators.js.map